import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = allArticles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">编辑团队精心挑选的优质内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}